/**
 * useScheduleDraftFlightFormOptions — ScheduleDraft 航班表单引用数据选项入口。
 *
 * 本 hook 消费统一引用数据 hooks，并用 Feature mapper 生成航班新增/编辑表单
 * 使用的机场与飞机选项。它让表单组件只处理 option，不直接理解 master data
 * 原始结构。
 *
 * 设计文档 → docs/10_core_contracts/12_api_v3_frontend_boundary.md
 * 骨架关联 → lib/referenceDataMappers.js (option mapper), components/ScheduleDraftFlightForm.jsx (表单消费), services/scheduleDraftReferenceDataService.js (引用数据边界)
 */

import { useMemo } from "react";
import { useAirports, useAircrafts } from "../../../../hooks/useReferenceData";
import { mapAircraftOption, mapAirportOption } from "../lib/referenceDataMappers";

export function useScheduleDraftFlightFormOptions(enabled = true) {
    const airportsQuery = useAirports({ enabled });
    const aircraftsQuery = useAircrafts({ enabled });

    const airportOptions = useMemo(() => airportsQuery.airportsList.map(mapAirportOption), [airportsQuery.airportsList]);
    const aircraftOptions = useMemo(() => aircraftsQuery.aircrafts.map(mapAircraftOption), [aircraftsQuery.aircrafts]);

    return {
        airports: airportsQuery.airportsList,
        airportOptions,
        aircraftOptions,
        aircrafts: aircraftsQuery.aircrafts,
        aircraftMap: aircraftsQuery.aircraftMap,
        isLoading: airportsQuery.isLoading || aircraftsQuery.isLoading,
    };
}

export default useScheduleDraftFlightFormOptions;
